import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './PaymentResult.module.css';
import Button from '../components/Button';
import Card from '../components/Card';
import { XCircleIcon } from '../components/Icons';

function PaymentFailed() {
  const navigate = useNavigate();
  const location = useLocation();
  const { error } = location.state || {};

  return (
    <div className={styles.container}>
      <Card className={styles.resultCard}>
        <div className={styles.iconWrapper + ' ' + styles.error}>
          <XCircleIcon size={48} />
        </div>
        <h1 className={styles.title}>Payment Failed</h1>
        <p className={styles.message}>
          {error || 'There was an issue processing your payment. Please try again.'}
        </p>

        <div className={styles.actions}>
          <Button onClick={() => navigate('/plans')}>
            Try Again
          </Button>
          <Button variant="secondary" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
}

export default PaymentFailed;
